module.exports = {
  title: 'React Native Floating Modal Animation 📦',
  author: 'Enzo Manuel Mangano',
  date: '2023-05-03',
  slug: 'floating-modal',
  tags: ['reanimated', 'gesture-handler'],
};
